import Configurator from "./components/Configurator.vue";
import "./plugins/vuetify";
import { defineComponent } from "vue";
import { mapState } from "vuex";
import Loading from "./components/Loading.vue";
export default defineComponent({
  name: "App",
  components: {
    Configurator,
    Loading
  },
  data() {
    return {
      appDark: false,
      menuOpen: false,
      isFullscreen: false
    };
  },
  mounted() {
    window.configuratorEventBus.$on('cfg-personalizzazione', n => {
      console.log('cfg-personalizzazione', n);
    });
    window.configuratorEventBus.$on('cfg-add-to-cart', n => {
      console.log('cfg-add-to-cart', n);
    });
    window.configuratorEventBus.$on('cfg-user-session', n => {
      console.log('cfg-user-session', n);
    });
    // Keep isFullscreen in sync with browser fullscreen changes
    const onFsChange = () => {
      // @ts-ignore
      this.isFullscreen = !!(document.fullscreenElement || document.webkitFullscreenElement || document.mozFullScreenElement || document.msFullscreenElement);
    };
    document.addEventListener('fullscreenchange', onFsChange);
    document.addEventListener('webkitfullscreenchange', onFsChange);
    document.addEventListener('mozfullscreenchange', onFsChange);
    document.addEventListener('MSFullscreenChange', onFsChange);
    // store to remove later
    // @ts-ignore
    this.__onFsChange = onFsChange;
  },
  beforeDestroy() {
    window.configuratorEventBus.$off('cfg-personalizzazione');
    window.configuratorEventBus.$off('cfg-add-to-cart');
    window.configuratorEventBus.$off('cfg-user-session');
    // Remove fullscreen listeners
    // @ts-ignore
    const onFsChange = this.__onFsChange;
    if (onFsChange) {
      document.removeEventListener('fullscreenchange', onFsChange);
      document.removeEventListener('webkitfullscreenchange', onFsChange);
      document.removeEventListener('mozfullscreenchange', onFsChange);
      document.removeEventListener('MSFullscreenChange', onFsChange);
    }
  },
  computed: {
    ...mapState(["marchio"]),
    marchio: {
      get() {
        return this.$store.state.marchio;
      },
      set(value) {
        this.$store.commit("setMarchio", value);
      }
    },
    itemsLoaded() {
      return this.$store.state.itemsLoaded;
    },
    isConfigMode() {
      const mode = process.env.VUE_APP_CONFIG_MODE || 'false';
      return mode.toLowerCase() === 'true';
    }
  },
  methods: {
    setMarchio(value) {
      this.marchio = value;
      this.menuOpen = false;
    },
    toggleFullscreen() {
      if (this.isFullscreen) {
        this.exitFullscreen();
      } else {
        this.enterFullscreen();
      }
    },
    enterFullscreen() {
      const el = this.$el;
      const anyEl = el;
      if (el.requestFullscreen) el.requestFullscreen();else if (anyEl.webkitRequestFullscreen) anyEl.webkitRequestFullscreen();else if (anyEl.mozRequestFullScreen) anyEl.mozRequestFullScreen();else if (anyEl.msRequestFullscreen) anyEl.msRequestFullscreen();
    },
    exitFullscreen() {
      const anyDoc = document;
      if (document.exitFullscreen) document.exitFullscreen();else if (anyDoc.webkitExitFullscreen) anyDoc.webkitExitFullscreen();else if (anyDoc.mozCancelFullScreen) anyDoc.mozCancelFullScreen();else if (anyDoc.msExitFullscreen) anyDoc.msExitFullscreen();
    }
  },
  watch: {
    appDark(val) {
      //@ts-ignore
      this.$vuetify.theme.dark = val;
    }
  }
});